export default {
  getProjectWarranties: state =>  {
    return state.projects
  },
}